import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  CONSENT_GRANTED,
  isAnalyticsEnabled,
  subscribeToConsent,
  trackPageView,
} from '../../utils/analytics';

/**
 * Tracks SPA page views in GA4 when the user has granted analytics consent.
 */
const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (!isAnalyticsEnabled()) return;
    trackPageView(location.pathname, location.search);
  }, [location]);

  useEffect(() => {
    return subscribeToConsent((consent) => {
      if (consent === CONSENT_GRANTED) {
        trackPageView(location.pathname, location.search);
      }
    });
  }, [location.pathname, location.search]);

  return null;
};

export default PageViewTracker;
